import React from 'react'

const ReferencesFilters = (props) => {
    let filterItems = (
        <div
            className="filter-item filter-item--loading"
        >
            <span className="filter-item__text">
                #SVE
            </span>
        </div>
    )
    if (props.filterData.length > 0) {
        if (props.filterData.length > 0) {
            const allFilters = props.filterData.slice()
            allFilters.unshift(props.allFilterText)
            filterItems = allFilters.map((val, key) => {
                let activeFilterClass = ''
                if (props.activeFilter === key) {
                    activeFilterClass = 'filter-item--active'
                }
                return (
                    <div
                        className={`filter-item ${activeFilterClass}`}
                        key={key}
                        onClick={props.setActiveFilter.bind(null, key, val)}
                    >
                        <span className="filter-item__text">
                            #{val}
                        </span>
                    </div>
                )
            })
        }
    }

    return (
        <div className="filters-container">
            <div className="col-md-12">
                <h3 className="filters-title">{props.filterTitle}</h3>
            </div>
            <div className="col-md-12">
                <div className="filter-items-container">
                    {filterItems}
                </div>
            </div>
        </div>
    )
}

ReferencesFilters.defaultProps = {
    filterData: [],
    activeFilter: 0,
    filterTitile: '',
    allFilterText: '',
    setActiveFilter: () => {}
}

export default ReferencesFilters



// WEBPACK FOOTER //
// ./src/scripts/components/ReferencesFilters.jsx